import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'

import { EmpresaQueVendeComCartoes } from '../../pkw-data/collect/empresa-que-vende-com-cartoes.model'
import { EmpresaQueVendeComCartoesService } from '../services/empresa-que-vende-com-cartoes.service'

@Injectable()
export class TodasEmpresasQVCCResolver implements Resolve<EmpresaQueVendeComCartoes[]> {
    constructor(private empresaQVCCService: EmpresaQueVendeComCartoesService) {}

    resolve() {
        return this.empresaQVCCService.obterTodas()
    }
}



// WEBPACK FOOTER //
// ./src/app/core/resolvers/todas-empresas-qvcc.resolver.ts